import { SignIn } from 'actions/actionTypes';

export const changeId = (id) => ({ type: SignIn.CHANGE_ID, payload: id });
export const changePassword = (password) => ({ type: SignIn.CHANGE_PASSWORD, payload: password });
export const changeRemember = (remember) => ({ type: SignIn.CHANGE_REMEMBER, payload: remember });

export const resetData = () => ({ type: SignIn.RESET_DATA });

export const signInRequest = () => ({ type: SignIn.SIGN_IN_REQUEST });